<template>
  <div>
    <Header />
    <div class="all-works">
      <div class="page-header">
        <div class="back-btn" @click="fanhui">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <h2>{{ isExcellentWorks ? '优秀作品库' : '科普作品库' }}</h2>
      </div>
      <div class="search-area">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <!-- <el-form-item label="项目编码">
            <el-select v-model="searchForm.projectCode" placeholder="请选择项目编码" clearable>
              <el-option
                v-for="item in projectCodeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目案例">
            <el-input v-model="searchForm.projectCase" placeholder="请输入项目案例" clearable></el-input>
          </el-form-item> -->
          <el-form-item label="作品名称">
            <el-input v-model="searchForm.worksName" placeholder="请输入作品名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="作者">
            <el-input v-model="searchForm.userName" placeholder="请输入作者" clearable></el-input>
          </el-form-item>
          <el-form-item label="单位">
            <el-input v-model="searchForm.userUnit" placeholder="请输入单位" clearable></el-input>
          </el-form-item>
          <el-form-item label="作品类型">
            <el-select v-model="searchForm.worksType" placeholder="请选择作品类型" clearable>
              <el-option
                v-for="item in worksTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="video-grid" v-loading="isLoading">
        <div v-for="(video) in videos" :key="video.id" class="video-item" @click="goToVideo(video)">
          <div class="video-player-wrap">
            <div class="video-container">
              <template v-if="video.worksType === '1' || video.worksType === '2'">
                <img :src="video.poster" class="doc-icon full-cover" alt="封面">
              </template>
              <template v-else>
                <!-- 视频类型显示视频 -->
                <div class="video-thumbnail-container">
                  <img v-if="video.poster" :src="video.poster" class="video-cover" :alt="video.title">
                  <video 
                    v-else
                    :src="video.url" 
                    class="video-cover" 
                    ref="videoRefs"
                    :poster="defaultPoster"
                    muted
                    playsinline
                    webkit-playsinline
                    x5-video-player-type="h5"
                    x5-video-player-fullscreen="true"
                    x5-video-orientation="portraint"
                    x-webkit-airplay="allow"
                  ></video>
                  <div v-if="loadingThumbnails[video.id]" class="loading-overlay">
                    <i class="el-icon-loading"></i>
                  </div>
                </div>
              </template>
            </div>
            <div class="play-icon" v-if="!video.id && (video.worksType === '3' || video.worksType === '4')">
              <i class="el-icon-video-play"></i>
            </div>
          </div>
          <div class="video-title">{{ video.title }}</div>
          <!-- <div class="video-desc">{{ video.description }}</div> -->
        </div>
      </div>
      <!-- 添加分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          layout="total, prev, pager, next"
          background>
        </el-pagination>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../header/head.vue';
import Footer from '../header/footer.vue';
import axios from 'axios'; // 导入axios

// 配置axios默认值
axios.defaults.baseURL = process.env.VUE_APP_BASE_API || 'http://localhost:8080';
axios.defaults.headers.common['Content-Type'] = 'application/json';

export default {
  name: 'AllWorks',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      videos: [], // 初始化为空数组
      apiVideos: [], // 存储API返回的视频数据
      isExcellentWorks: false, // 是否是优秀作品页面
      searchForm: {
        projectCode: '', // 项目编码
        projectCase: '', // 项目案例（主题）
        worksName: '', // 作品名称
        userName: '', // 用户名称
        userUnit: '', // 用户单位
        worksType: '' // 作品类型
      },
      projectCodeOptions: [], // 项目编码选项
      // 作品类型选项
      worksTypeOptions: [
        { label: '科普文章', value: '1' },
        { label: '科普图画', value: '2' },
        { label: '科普短视频', value: '3' },
        { label: '科普讲座', value: '4' }
      ],
      defaultPoster: 'https://bxxcx.bahim.org.cn/profile/upload/2025/03/06/logo.jpg',
      wordIcon: require('../../assets/applyRey/word.png'),
      loadingThumbnails: {},
      isLoading: false, // 添加全局加载状态
      activeVideoElements: new Set(), // 存储活动的视频元素
      isComponentActive: true, // 标记组件是否处于活动状态
      thumbnailPromises: [], // 存储所有缩略图生成的Promise
      // 添加分页相关数据
      pagination: {
        pageNum: 1,
        pageSize: 24,
        total: 0
      },
    }
  },
  methods: {
    // 检查是否是优秀作品页面
    checkIsExcellentWorks() {
      return this.$route.query.type === 'excellent';
    },

    // 获取API视频数据
    async fetchApiVideos() {
      this.isLoading = true;
      try {
        // 构建请求参数
        const params = {
          ...this.searchForm,
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        };

        // 移除空值参数
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === undefined) {
            delete params[key];
          }
        });

        // 根据是否是优秀作品页面选择不同的接口
        const apiUrl = this.isExcellentWorks ? '/system/works/goodjianji/list' : '/system/works/jianji/list';
        const response = await axios.get(apiUrl, { params });
        
        if (response.data.code === 200) {
          this.apiVideos = response.data.rows || [];
          // 更新总数
          this.pagination.total = response.data.total || 0;
          // 合并数据
          this.mergeVideoData();
        } else {
          console.error('获取视频列表失败:', response.data.msg);
        }
      } catch (error) {
        console.error('获取视频列表出错:', error);
        this.apiVideos = [];
        this.mergeVideoData();
      } finally {
        this.isLoading = false;
      }
    },

    // 合并数据 - 现在只处理API数据
    mergeVideoData() {
      // 将API视频数据转换为统一格式
      const formattedApiVideos = this.apiVideos.map(video => {
        let videoUrl = video.vedioFile || '';
        let posterUrl = video.picFile
          ? video.picFile.replace('http://bxxcxbackend.bahim.org.cn', 'https://bxxcx.bahim.org.cn')
          : this.defaultPoster;
        return {
          id: video.id,
          title: video.worksName,
          description: video.des || '',
          author: video.userName || '',
          organization: video.userUnit || '',
          url: videoUrl,
          projectTheme: video.projectCase || '无',
          poster: posterUrl,
          worksType: video.worksType
        };
      }).filter(video => video.url);

      // 直接设置为API数据
      this.videos = formattedApiVideos;
    },

    onVideoLoaded(event) {
      const video = event.target;
      video.muted = true;
      video.style.display = 'block';
    },

    goToVideo(video) {
      if (!video || !video.id) {
        console.error('goToVideo: video object or video.id is undefined', video);
        return;
      }
      // 根据是否是优秀作品页面选择不同的参数名
      const queryParam = this.isExcellentWorks ? 'goodvideoId' : 'videoId';
      this.$router.push({
        path: '/sample-video',
        query: { 
          [queryParam]: video.id
        }
      });
    },

    // 重置所有视频状态
    resetAllVideos() {
      if (this.$refs.videoRefs) {
        this.$refs.videoRefs.forEach(video => {
          if (video) {
            video.load();
            video.pause();
            video.style.display = 'block';
          }
        });
      }
    },

    fanhui() {
      this.resetAllVideos();
      this.$nextTick(() => {
        this.$router.push('/works');
      });
    },

    // 处理搜索
    async handleSearch() {
      await this.fetchApiVideos();
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        projectCode: '',
        projectCase: '',
        worksName: '',
        userName: '',
        userUnit: '',
        worksType: ''
      };
      this.pagination.pageNum = 1; // 重置到第一页
      this.fetchApiVideos();
    },

    // 添加分页处理方法
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchApiVideos();
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.fetchApiVideos();
    },

    // 获取项目编码选项
    async fetchProjectCodes() {
      try {
        const response = await axios.get('/api/v1/works/projectquery');
        if (response.data.code === 200) {
          // 只使用xmCode作为选项
          this.projectCodeOptions = response.data.data.map(item => ({
            value: item.xmCode,
            label: item.xmCode
          }));
        } else {
          console.error('获取项目编码列表失败:', response.data.msg);
        }
      } catch (error) {
        console.error('获取项目编码列表出错:', error);
      }
    },
  },
  async mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize);
    }
    
    // 根据URL参数判断是否是优秀作品页面
    this.isExcellentWorks = this.checkIsExcellentWorks();
    
    // 获取项目编码选项
    await this.fetchProjectCodes();
    
    // 初始化数据
    await this.fetchApiVideos();
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize);
    }
    this.resetAllVideos();
  },
  activated() {
    this.$nextTick(() => {
      this.resetAllVideos();
    });
  },
  deactivated() {
    this.resetAllVideos();
  },
  watch: {
    // 监听路由变化
    '$route'(to) {
      this.isExcellentWorks = this.checkIsExcellentWorks();
      this.fetchApiVideos(); // 重新获取数据
    }
  }
}
</script>

<style scoped>
.all-works {
  padding: 20px;
}

.page-header {
  position: relative;
  margin-bottom: 20px;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s;
  margin-bottom: 10px;
}

.back-btn:hover {
  color: #409EFF;
  background: #f5f7fa;
}

.back-btn i {
  margin-right: 4px;
  font-size: 16px;
}

.page-header h2 {
  text-align: center;
  margin: 20px 0;
  color: #333;
  font-size: 24px;
}

.search-area {
  margin-bottom: 20px;
  padding: 15px;
  /* background-color: #f5f7fa; */
  border-radius: 8px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.search-form .el-form-item {
  margin-bottom: 0;
  margin-right: 0;
}

.search-form :deep(.el-form-item__label) {
  font-weight: bold !important;
}

.search-form .el-input {
  width: 200px;
}

/* 添加搜索按钮样式 */
.search-form :deep(.el-button--primary) {
  background-color: #58C1B6 !important;
  border-color: #58C1B6 !important;
}

.search-form :deep(.el-button--primary:hover),
.search-form :deep(.el-button--primary:focus) {
  background-color: #4BA89E !important;
  border-color: #4BA89E !important;
}

.search-form :deep(.el-button--primary:active) {
  background-color: #3E8F86 !important;
  border-color: #3E8F86 !important;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
  margin-top: 20px;
  min-height: 200px;
}

.video-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.video-player-wrap {
  width: 247px;
  height: 440px;
  background: #000;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.video-cover,
.image-cover {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
  background: #000000;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  z-index: 1;
}

.video-player-wrap:hover .play-icon {
  background: rgba(0, 0, 0, 0.7);
  transform: translate(-50%, -50%) scale(1.1);
}

.play-icon i {
  color: #fff;
  font-size: 30px;
}

.video-title {
  margin-top: 8px;
  font-size: 14px;
  text-align: center;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 5px;
  width: 220px;
}

.video-desc {
  font-size: 13px;
  color: #666;
  margin-top: 2px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 5px;
  width: 220px;
}

@media screen and (max-width: 768px) {
  .video-grid {
    display: flex;
    gap: 10px;
    padding-bottom: 20px;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .video-item {
    width: calc(50% - 5px);
    margin-bottom: 10px;
  }

  .video-player-wrap {
    width: 100%;
    height: 200px;
  }

  .video-title {
    font-size: 12px;
    margin-top: 5px;
    width: 100%;
  }

  .video-desc {
    font-size: 11px;
    margin-top: 2px;
    width: 100%;
  }

  .search-form {
    flex-direction: column;
  }
  
  .search-form .el-form-item {
    width: 100%;
  }
  
  .search-form .el-input {
    width: 100%;
  }
}

/* 添加新的样式 */
.doc-icon {
  width: 64px;
  height: 64px;
  object-fit: contain;
  margin: auto;
}

/* 新增：让文档类型图片撑满容器 */
.full-cover {
  width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  margin: 0 !important;
}

.image-cover {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.video-thumbnail-container {
  position: relative;
  width: 100%;
  height: 100%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.loading-overlay i {
  font-size: 24px;
  color: #409EFF;
}

.el-select {
  width: 200px;
}

@media screen and (max-width: 768px) {
  .el-select {
    width: 100%;
  }
}

/* 添加分页样式 */
.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

/* 自定义分页样式 */
.pagination-container :deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
  background-color: #58C1B6;
}

.pagination-container :deep(.el-pagination.is-background .el-pager li:not(.disabled):hover) {
  color: #58C1B6;
}

@media screen and (max-width: 768px) {
  .pagination-container {
    margin-top: 15px;
  }
}
</style> 